// src/com/auto_plan_bind/AutoPlanBindDict.js
import { InputType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// 점포별 동적 정보, auto_plan_bind
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '센터',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '3자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 3)},
	}, // varchar(3)
    planDate : {
		id: 'planDate', label: '배차일',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // date
    bindIndex : {
		id: 'bindIndex', label: '동적구분',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 1 && value <= 10},
	}, // int(2)
    targetStoreId : {
		id: 'targetStoreId', label: '대상점포',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 1, 10)},
	}, // varchar(10)
    targetHocha : {
		id: 'targetHocha', label: '호차',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 1 && value <= 20},
	}, // int(11)
    bindStoreId : {
		id: 'bindStoreId', label: '동적점포',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
        valueKey: 'storeId', labelKey: 'storeName',
        getOptionLabel: (opt) => '[' + opt.storeId + '] ' + opt.storeName,
		check: (value) => {return IsValid.string(value, 1, 10)},
	}, // varchar(10)
    bindHocha : {
		id: 'bindHocha', label: '동적호차',
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 1 && value <= 20},
	}, // int(11)
};

/**
 * AUTO_PLAN_BIND React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2026-06-24 19:51:18 using DbdbTap
 * https://www.dbdbtap.com
 */
export const AutoPlanBindDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '동적정보 저장 오류',
        Edit: '동적정보 수정 오류',
        Remove: '동적정보 삭제 오류',
        Get: '동적정보 조회 오류',
    },
    /* tableProps: {
        tableId: 'autoPlanBindTable',
        uniqueKey: 'dcCd_planDate_bindIndex_targetStoreId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'planDate', label: Dict.planDate.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'bindIndex', label: Dict.bindIndex.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'targetStoreId', label: Dict.targetStoreId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'targetHocha', label: Dict.targetHocha.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'bindStoreId', label: Dict.bindStoreId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'bindHocha', label: Dict.bindHocha.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    }, */
};
